import SceCheckbox from '../../../../../../../Common/CommonComponents/SceCheckBox';
import React from 'react';
import classes from './selectedContactComponent.scss';
import { getLocalizedStrings } from '../../../notificationLocalizedStrings';
import SetUpVoiceDropdown from './voiceDropDown';
import SetUpEmailDropdown from './emailDropdown';
import SetUpTextDropdown from './textDropdown';
import NotificationHelper from './dropDown/notificationHelper';
import SceErrorBox from '../../../../../../../Common/ErrorBox/sceErrorBox';
import SceTextBox from '../../../../../../../Common/TextBox/sceText';

class SelectedContactComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleDrawerStatus: false,
            addEmail: false,
            removeIcon:false,
            removeButtonPress:false,
            editButtonPress:false,
            doneButtonPress:false,
            isAddBtnDisabled:false,
            isSelected:true,
            isAddBox:false
        };
        
        this.strings = getLocalizedStrings('dialogBox');
        let editIcon;
        this.editIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/CTA_Edit_Small.svg';
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';

        let emailIcon;
        let closeIcon;
        let addIcon;
        let removeIcon;
        this.removeIcon= drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
        this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
        this.closeIcon=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
    }

 componentDidMount(){
    //  alert(this.props.isNewContactAdded);
 }   
    // ms call to add email if not present in master data
    addButtonHandler(){
        const updatedState={...this.state};
        // this.props.addContactCheckedStatusArr[this.props.contactType][this.props.contactMethodIndex];
        // this.props.onContactMethodCheckHandler(this.props.contactType, this.props.contactMethodIndex);
        updatedState.isAddBtnDisabled=true;
        updatedState.isSelected=true;
        updatedState.isAddBox=false;
        this.setState(updatedState); 
    }

    editButtonHandler(){
        const updatedState={...this.state};
        // updatedState.editButtonPress=true;
        updatedState.isSelected=false;
        // updatedState.toggleDrawerStatus=true;
        this.setState(updatedState);
    }
    editCancelBtnHandler(){
        const updatedState={...this.state};
        updatedState.isSelected=true;
        updatedState.editButtonPress=false;
        this.setState(updatedState);
        
    }
    // call modify ms call
    editSaveBtnHandler(){
        const updatedState={...this.state};
        
        this.setState(updatedState);

    }
    removeIconHandler=()=>{
        const updatedState={...this.state};
        updatedState.removeButtonPress=true;
        updatedState.isSelected=false;
        this.setState(updatedState,()=>{
            this.props.onDoneEnabledButton(true);
        });
    }
    removeButtonHandler= () => 
    {
        const updatedState={...this.state};
        //this.props.onContactMethodCheckHandler(this.props.contactType,this.props.contactMethodIndex);
        updatedState.addEmail=false;
        updatedState.removeIcon=false;
        updatedState.removeButtonPress=false;
        updatedState.editButtonPress=false;
        updatedState.doneButtonPress=false;
        updatedState.isAddBtnDisabled=false;
        updatedState.isSelected=true;
        updatedState.isAddBox=false;
        //this.setState(updatedState);
        this.props.onDoneEnabledButton(false);
        this.setState(updatedState,()=>{
             this.props.onContactMethodCheckHandler(this.props.contactType,this.props.contactMethodIndex);
        });
      
    }
    removeCancelBtnHandler=()=>{
        const updatedState={...this.state};
        updatedState.removeButtonPress=false;
        updatedState.isSelected=true;
        //this.setState(updatedState);
        this.setState(updatedState,()=>{
            this.props.onDoneEnabledButton(false);
        });

    }
    // editButtonHandler()
    // {
    //     const updatedState={...this.state};
    //     updatedState.editButtonPress=true;
    //     this.setState(updatedState);
    // }
    doneButtonHandler()
    {
        const updatedState={...this.state};
        updatedState.doneButtonPress=true;
        this.setState(updatedState);
        //alert(updatedState);
    }
    cancelButtonHandler=()=>{
        const updatedState={...this.state};
        updatedState.removeButtonPress=false;
        updatedState.removeIcon=false;
        updatedState.editButtonPress=true;
        this.setState(updatedState);
    }
    onContactDrawerToggleHandler = () => {
        let updatedData = { ...this.state };
        updatedData.toggleDrawerStatus = !updatedData.toggleDrawerStatus;
        this.props.onDoneEnabledButton(updatedData.toggleDrawerStatus);
        this.setState(updatedData, () => { });
    }
    onSelectDropDown = (e, contactMethodIndex) => {
        this.onContactDrawerToggleHandler();
        this.props.onSelectDropDown(e, contactMethodIndex);
    }
    handleClick = (e) => this.setState({isAddClicked:true});
    render() {
        // alert("SCC"+JSON.stringify(this.props.data));
        const contactType = this.props.contactType;
        const addContactValue = this.props.addContactValueArr[contactType];
        const addContactCheckedStatusArr = this.props.addContactCheckedStatusArr[contactType];
        const contactMethodIndex = this.props.contactMethodIndex;
        
        return (
            <div className={classes.selectedContactComponent} >
                {!this.state.toggleDrawerStatus ?
                    <React.Fragment> 
                        
                        <div className='row'>
                            {/* <SceCheckbox
                                id={contactType + 'Checkbox' + contactMethodIndex}
                                selectedOptions={addContactCheckedStatusArr[contactMethodIndex]}
                                handleClick={() => this.props.onContactMethodCheckHandler(contactType, contactMethodIndex)}formatEmailIdWithStar
                                araia-labelledby={contactType + 'CheckboxLabel' + contactMethodIndex}
                                focusOnCheckBoxIcon
                                options={contactType==="email"?addContactValue[contactMethodIndex]:NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}
                            /> */}
                            {(this.state.isAddBox)
                            ?<div>
                                <div className={classes.box}>
                                        <span className={classes.sceTextBox}>
                                            <SceTextBox 
                                                type="text" 
                                                defaultValue={contactType==="email"?NotificationHelper.formatEmailIdWithStar(addContactValue[contactMethodIndex]):NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}
                                            />
                                        </span>
                                        <span className={classes.addCancelButtonAlign}>
                                            <span className={classes.addButtonAlign}>
                                                <button 
                                                    className={this.state.isAddBtnDisabled ? classes.AddDisabledButton : classes.AddButton}
                                                    onClick={this.addButtonHandler.bind(this)}
                                                    >
                                                    {"Add"}
                                                </button>
                                            </span>
                                            <span className={classes.EditButtonAlign}>
                                                <button className={classes.CancelButton} 
                                                onClick={this.cancelButtonHandler.bind(this)}>Cancel</button>
                                            </span>
                                        </span>

                                    </div>
                                    {/* <div className={classes.dividerLine} /> */}
                            </div>
                            :null}
                            
                            {(this.state.isSelected)?
                                    <span>
                                      <button className={classes.sceCPPDeleteicon} onClick={this.removeIconHandler.bind(this)} >  <img src={this.removeIcon} alt="Remove Icon"  /> </button> 
                                        <span className={classes.emailData}>{contactType==="email"?NotificationHelper.formatEmailIdWithStar(addContactValue[contactMethodIndex]):NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}</span>
                                            <span className={classes.editButtonAlign}>
                                                <button className={classes.EditButton} onClick={() => this.onContactDrawerToggleHandler()} >Edit</button>
                                            </span>
                                         <div className={classes.dividerLine} />
                                    </span>
                                    :null}
                            
                            {(this.state.editButtonPress)?
                                <div>
                                {/* save /cancel ui page */}
                                    <div className={classes.box}>
                                        <span className={classes.sceTextBox}>
                                            {/* <PbInputDropDown selectBoxData={this.props.emailPreferences} defaultText={"Enter Email"} /> */}
                                            <SceTextBox type="text" 
                                                defaultValue={contactType==="email"?NotificationHelper.formatEmailIdWithStar(addContactValue[contactMethodIndex]):NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])} />
                                        </span>
                                        <span className={classes.addCancelButtonAlign}>
                                            <span className={classes.addButtonAlign}>
                                                <button className={classes.AddButton}>Save</button>
                                            </span>
                                            <span className={classes.editButtonAlign}>
                                                <button className={classes.CancelButton} onClick={this.editCancelBtnHandler.bind(this)}>Cancel</button>
                                            </span>
                                        </span>

                                    </div>
                                </div>
                            :null}
                            
                            {(this.state.removeButtonPress)?
                             <span>
                                <span className={classes.emailData}>{contactType==="email"?NotificationHelper.formatEmailIdWithStar(addContactValue[contactMethodIndex]):NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}</span>
                                    <span className={classes.buttonAlign}>
                                        <span className={classes.removeButtonAlign}>
                                        <button className={classes.RemoveButton} onClick={this.removeButtonHandler.bind(this)}>Remove</button>
                                        </span>
                                        <span className={classes.EditButtonAlign}>
                                            <button className={classes.CancelButton} onClick={this.removeCancelBtnHandler.bind(this)}>Cancel</button>
                                        </span>
                                    </span>
                                     <div className={classes.dividerLine} />
                            </span>
                            :null}
                           </div>
                        <div className={classes.sceErrorDiv} >
                            <SceErrorBox id={contactType + 'CheckboxError' + contactMethodIndex} errorMessage={this.strings[contactType+'SameValueErrorMsg']} isError={this.props.isSameValueSelectError[contactType][contactMethodIndex]} />
                        </div>
                    </React.Fragment>
                    :
                    contactType === 'email' ?
                        <div className={classes.sceTextBoxData}>
                            <SetUpEmailDropdown
                                triggerOnClick={() => this.onContactDrawerToggleHandler('email')}
                                onModifyCustomerPreference={(deviceType, value, maskedValue)=>this.props.onModifyCustomerPreference(deviceType, value, maskedValue, contactMethodIndex)}
                                id={'email'}
                                dropdownDiffererentiator={this.props.dropdownDiffererentiator}
                                fieldType={this.strings.primaryContact}
                                index={this.props.index}
                                reloadManageAlertPref={this.props.reloadManageAlertPref}
                                data={this.props.data}
                                selectedValue={addContactValue[contactMethodIndex]}
                                onDoneEnabledButton={this.props.onDoneEnabledButton}
                                premiseData={NotificationHelper.getPremiseData('preferEmail', addContactValue[contactMethodIndex])}
                                onSelectDropDown={(e) => this.onSelectDropDown(e, contactMethodIndex)}
                                showGloabalError={this.props.showGloabalError}
                                showLoadingSpinner={this.props.showLoadingSpinner}
                                hideLoadingSpinner={this.props.hideLoadingSpinner}
                                isDropDownError={this.props.isDropDownSelectError[contactMethodIndex]}
                                isSameValueError={this.props.isSameValueSelectError[contactMethodIndex]}
                                dropDownData={this.props.dropDownData}
                                inputButtonText={this.strings.inputEditButtonText}
                                addContactValueArr={this.props.addContactValueArr}
                            />
                        </div>
                        :
                        contactType === 'voice' ?
                            <div className={classes.sceTextBoxData}>
                                <SetUpVoiceDropdown
                                    triggerOnClick={() => this.onContactDrawerToggleHandler('voice')}
                                    onModifyCustomerPreference={(deviceType, value, maskedValue)=>this.props.onModifyCustomerPreference(deviceType, value, maskedValue, contactMethodIndex)}
                                    id={'voice'}
                                    dropdownDiffererentiator={this.props.dropdownDiffererentiator}
                                    fieldType={this.strings.primaryContact}
                                    index={this.props.index}
                                    reloadManageAlertPref={this.props.reloadManageAlertPref}
                                    data={this.props.data}
                                    selectedValue={NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}
                                    onDoneEnabledButton={this.props.onDoneEnabledButton}
                                    premiseData={NotificationHelper.getPremiseData('preferVoice', addContactValue[contactMethodIndex])}
                                    onSelectDropDown={(e) => this.onSelectDropDown(e, contactMethodIndex)}
                                    showGloabalError={this.props.showGloabalError}
                                    isDropDownError={this.props.isDropDownSelectError[contactMethodIndex]}
                                    isSameValueError={this.props.isSameValueSelectError[contactMethodIndex]}
                                    dropDownData={this.props.dropDownData}
                                    inputButtonText={this.strings.inputEditButtonText}            
                                    addContactEncValueArr={this.props.addContactEncValueArr}
                               />
                            </div>
                            :
                            <div className={classes.sceTextBoxData}>
                                <SetUpTextDropdown
                                    triggerOnClick={() => this.onContactDrawerToggleHandler('text')}
                                    onModifyCustomerPreference={(deviceType, value, maskedValue)=>this.props.onModifyCustomerPreference(deviceType, value, maskedValue, contactMethodIndex)}
                                    id={'text'}
                                    dropdownDiffererentiator={this.props.dropdownDiffererentiator}
                                    fieldType={this.strings.primaryContact}
                                    index={this.props.index}
                                    reloadManageAlertPref={this.props.reloadManageAlertPref}
                                    data={this.props.data}
                                    selectedValue={NotificationHelper.formatPhoneNumWithStar(addContactValue[contactMethodIndex])}
                                    onDoneEnabledButton={this.props.onDoneEnabledButton}
                                    premiseData={NotificationHelper.getPremiseData('preferText', addContactValue[contactMethodIndex])}
                                    onSelectDropDown={(e) => this.onSelectDropDown(e, contactMethodIndex)}
                                    showGloabalError={this.props.showGloabalError}
                                    showLoadingSpinner={this.props.showLoadingSpinner}
                                    hideLoadingSpinner={this.props.hideLoadingSpinner}
                                    isDropDownError={this.props.isDropDownSelectError[contactMethodIndex]}
                                    isSameValueError={this.props.isSameValueSelectError[contactMethodIndex]}
                                    dropDownData={this.props.dropDownData}
                                    inputButtonText={this.strings.inputEditButtonText}
                                    addContactEncValueArr={this.props.addContactEncValueArr}                                  
                                />
                            </div>
                }
            </div>
        );
    }
}

export default SelectedContactComponent;
